export default "__VITE_ASSET__NUpt8XOP__"